import React, { useState, useEffect } from 'react';

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isOverCardStack, setIsOverCardStack] = useState(false);

  useEffect(() => {
    // Funzione per aggiornare la posizione del cursore
    const updatePosition = (e) => {
      // Aggiorna la posizione con un leggero ritardo per evitare blocchi
      requestAnimationFrame(() => {
        setPosition({ x: e.clientX, y: e.clientY });
      });
      
      if (!isVisible) setIsVisible(true);
    };

    // Funzione per gestire l'hover su elementi interattivi
    const handleMouseOver = (e) => {
      const targetElement = e.target;
      
      // Verifica se è un elemento del card stack
      const isCardStack = 
        targetElement.classList.contains('square') || 
        targetElement.closest('.square') !== null;
      
      // Se siamo su un elemento del card stack, nascondi il cursore personalizzato
      // per lasciare spazio al tooltip originale
      setIsOverCardStack(isCardStack);
      
      if (isCardStack) {
        return;
      }
      
      // Verifica se l'elemento o i suoi antenati sono interattivi
      const isInteractive = 
        targetElement.tagName === 'A' ||
        targetElement.tagName === 'BUTTON' ||
        targetElement.closest('a') !== null ||
        targetElement.closest('button') !== null ||
        targetElement.onclick !== null ||
        getComputedStyle(targetElement).cursor !== 'auto' && 
        getComputedStyle(targetElement).cursor !== 'none';
      
      setIsHovering(isInteractive);
    };

    // Funzione per gestire quando il mouse esce dalla finestra
    const handleMouseLeave = () => {
      setIsVisible(false);
      setIsOverCardStack(false);
    };

    // Funzione per gestire quando il mouse entra nella finestra
    const handleMouseEnter = () => {
      setIsVisible(true);
    };

    // Aggiungi gli event listener
    document.addEventListener('mousemove', updatePosition, { passive: true });
    document.addEventListener('mouseover', handleMouseOver);
    document.addEventListener('mouseleave', handleMouseLeave);
    document.addEventListener('mouseenter', handleMouseEnter);

    // Rimuovi gli event listener quando il componente viene smontato
    return () => {
      document.removeEventListener('mousemove', updatePosition);
      document.removeEventListener('mouseover', handleMouseOver);
      document.removeEventListener('mouseleave', handleMouseLeave);
      document.removeEventListener('mouseenter', handleMouseEnter);
    };
  }, [isVisible]);

  // Stile inline per il cursore personalizzato
  const cursorStyle = {
    left: `${position.x}px`,
    top: `${position.y}px`,
    opacity: isVisible && !isOverCardStack ? 1 : 0,
    transition: 'opacity 0.2s ease-out, width 0.15s ease-out, height 0.15s ease-out',
    pointerEvents: 'none'
  };

  return (
    <div 
      className={`custom-cursor ${isHovering ? 'hover' : ''}`} 
      style={cursorStyle} 
    />
  );
};

export default CustomCursor; 